import React, { ReactNode } from 'react'

export default function EdgeLabel(props: {
  style?: React.CSSProperties
  labelX?: number
  labelY?: number
  value: ReactNode | string
}) {
  return (
    <div
      style={{
        transform:
          props.labelX && props.labelY ? `translate(-50%, -50%) translate(${props.labelX}px,${props.labelY}px)` : '',
        ...props.style,
      }}
      // eslint-disable-next-line tailwindcss/no-custom-classname
      className="nodrag nopan absolute flex items-center justify-center gap-2 rounded-lg border border-border-primary-hover bg-fg-gray-primary px-3 py-1.5 font-medium"
    >
      <p className="font-medium text-text-secondary">{props.value}</p>
    </div>
  )
}
